import { render, staticRenderFns } from "./ProjectBuildingImporter.vue?vue&type=template&id=0dae0188&scoped=true&lang=html&"
import script from "./ProjectBuildingImporter.vue?vue&type=script&lang=ts&"
export * from "./ProjectBuildingImporter.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBuildingImporter.vue?vue&type=style&index=0&id=0dae0188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae0188",
  null
  
)

export default component.exports